export default "__VITE_ASSET__Dz4nM2Xb__"